/** Mirrors schema `Mutation.updatePalette(input: PaletteInput)`. */
export const mutationUpdatePalette = `
mutation updatePalette($input: PaletteInput) {
	updatePalette(input: $input) {
		success
	}
}
`;
